
import { ref } from 'vue'
import { useStore } from 'vuex'
import { Toast } from 'vant'

export default {
  emits: ['onEmit'],
  setup(props, ctx) {
    const password = ref('')
    const handleTrueClick = () => {
      if (password.value === '') {
        Toast({
          message: '请输入密码',
          position: 'bottom'
        })
        return false
      }
      ctx.emit('onEmit', password.value)
    }

    return {
      password,
      handleTrueClick
    }
  }
}
// 显示密码框逻辑
export const useShowPasswordEffect = () => {
  const store = useStore()
  const quesInfo = store.getters.getQuesInfo
  const isPassword = ref(0)
  isPassword.value = quesInfo?.isPassword
  // 处理输入密码
  const handlePasswordSubmit = item => {
    if (item === quesInfo?.password) {
      Toast({
        message: '密码输入成功',
        position: 'bottom'
      })
      isPassword.value = 0
    } else {
      Toast({
        message: '密码输入错误',
        position: 'bottom'
      })
    }
  }

  return {
    isPassword,
    handlePasswordSubmit
  }
}
